import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/app/layouts/default.vue").then(m => m.default || m)),
  auth: defineAsyncComponent(() => import("/app/layer/ui/layouts/auth.vue").then(m => m.default || m)),
  base: defineAsyncComponent(() => import("/app/layer/ui/layouts/base.vue").then(m => m.default || m)),
  login: defineAsyncComponent(() => import("/app/layer/ui/layouts/login.vue").then(m => m.default || m)),
  register: defineAsyncComponent(() => import("/app/layer/ui/layouts/register.vue").then(m => m.default || m)),
  ui: defineAsyncComponent(() => import("/app/layer/ui/layouts/ui.vue").then(m => m.default || m)),
  "without-login": defineAsyncComponent(() => import("/app/layer/ui/layouts/without-login.vue").then(m => m.default || m))
}